import { createFileRoute } from "@tanstack/react-router";
import { History } from "lucide-react";
import { EmptyState } from "@/components/empty-state";

export const Route = createFileRoute("/_authenticated/activity")({
  component: ActivityPage,
});

function ActivityPage() {
  return (
    <EmptyState
      title="Activity"
      description="Every change to your catalog and settings will read here: a running record of who did what, when. Activity history arrives in a later release."
      icon={History}
    />
  );
}
